/**
 * publishToPreWebpackWorld
 *
 * Disclaimer: I hate to do this, but native events aren't compatible or good enough so we need the
 * simplest thing to communicate an event from new world to old world. Alternatives are welcome.
 *
 * Usage from webpack world:
 *
 * publishToPreWebpackWorld('myEvent', params);
 *
 * Usage from pre webpack world:
 *
 * window.subscribeToWebpackWorld('myEvent', (params) => { ... })
 */

const publishToPreWebpackWorld = (name, params) => {
    if (window.subscribeToWebpackWorld) {
        window.subscribeToWebpackWorld.trigger(name, params);
    }
};

export default publishToPreWebpackWorld;

/** @var {string} - broadcast event name for changes made. */
export const EVENT_FORM_BUILDER_SAVED = 'FormBuilder:saved';
export const EVENT_FORM_RENDERER_SUBMIT_SUCCESS = 'FormRenderer:SubmitSuccess';
